<div class="toast-container">
  <div *ngFor="let toast of toasts$ | async"
       class="toast"
       [ngClass]="toast.type"
       [@toastAnimation]>
    <div class="toast-header">
      <i [class]="getIconClass(toast.type)"></i>
      <span class="toast-title">{{ toast.title }}</span>
      <button class="close-btn" (click)="removeToast(toast.id)">
        <i class="bi bi-x"></i>
      </button>
    </div>
    <div class="toast-body">
      {{ toast.message }}
    </div>
    <div *ngIf="toast.duration" class="progress-bar">
      <div class="progress" [style.animation-duration.ms]="toast.duration"></div>
    </div>
  </div>
</div>
